import { render, staticRenderFns } from "./sosCarDialog.vue?vue&type=template&id=e0af21be&scoped=true&"
import script from "./sosCarDialog.vue?vue&type=script&lang=js&"
export * from "./sosCarDialog.vue?vue&type=script&lang=js&"
import style0 from "./sosCarDialog.vue?vue&type=style&index=0&id=e0af21be&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0af21be",
  null
  
)

export default component.exports